/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RegionSelectIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Region Select',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.092 12.044C33.276 6.93 27.3 3.488 20.008 3.488a24.207 24.207 0 0 0-3.8.305C7.281 5.217.82 11.219 1.774 17.2a7.861 7.861 0 0 0 1.737 3.752 8.67 8.67 0 0 0-.015.417c0 2.737 2.732 4.956 6.1 4.956a7.239 7.239 0 0 0 .916-.075A6.6 6.6 0 0 1 11.8 28.1a2.434 2.434 0 0 1-.237 2.115 5.314 5.314 0 0 1-3.224 1.666.5.5 0 0 0-.414.541l.1 1a.5.5 0 0 0 .579.446c1.055-.187 3.409-.783 4.6-2.506a4.37 4.37 0 0 0 .528-3.779 5.847 5.847 0 0 0-1.117-1.928c.068-.032.118-.083.185-.116a22.05 22.05 0 0 0 3.06.218 24.22 24.22 0 0 0 3.8-.3c8.925-1.43 15.386-7.433 14.432-13.413ZM5.5 21.369a2.953 2.953 0 0 1 1.972-2.5 6.41 6.41 0 0 0-.142 3.063 6.544 6.544 0 0 0 1.44 2.329c-1.842-.284-3.27-1.493-3.27-2.892Zm5.752 2.691-.008-.008a10.663 10.663 0 0 1-1.974-2.608 5.815 5.815 0 0 1 .448-3.024c2.17.048 3.984 1.374 3.984 2.949a3.146 3.146 0 0 1-2.454 2.691Zm8.1-.584a22.2 22.2 0 0 1-3.488.28c-.369 0-.717-.042-1.077-.061l.619-.87a4.066 4.066 0 0 0 .3-1.456c0-2.738-2.731-4.957-6.1-4.957a6.615 6.615 0 0 0-4.87 1.988l-.249.4a5.594 5.594 0 0 1-.738-1.913C2.983 12.085 8.832 7 16.521 5.768a22.191 22.191 0 0 1 3.488-.28c6.381 0 11.473 2.89 12.108 6.871.766 4.799-5.083 9.89-12.772 11.117Z"
    />
  </svg>`;
};
